var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { GetSMTPImportLogsListPaginatedQuery, GetSMTPImportLogListPaginatedQuery, SMTPImporterClient, PaginatedEnumerableOfSMTPImportLogModel, SMTPImportLogDetailModel, SMTPImportStatusEnum, SMTPImportFileMessageTypeEnum, SortDescription, SortDirection, SMTPImportEmailLogStatus } from "@/app/api/battery-portal-api";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import { Alert } from "@/common/utils/alert";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch } from "vue-facing-decorator";
import moment from 'moment';
const smtpImporterClient = new SMTPImporterClient(window.apiUrl);
let SMTPImportLogsVue = class SMTPImportLogsVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.loading = false;
        this.working = false;
        this.searchAttempted = false;
        this.viewingLogDetails = false;
        // components
        this.msg = new Alert();
        this.sorter = new Sorter(new SortDescription({
            fieldName: "whenCreated",
            direction: SortDirection.Descending
        }));
        this.detailsSorter = new Sorter(new SortDescription({
            fieldName: "status",
            direction: SortDirection.Descending
        }));
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.dateFilterOptions = ["1 Day", "3 Days", "5 Days", "Week", "Month", "..."];
        this.dateFilterOption = "";
        // models
        this.data = new PaginatedEnumerableOfSMTPImportLogModel();
        this.logDetails = this.initializeLogDetailsModel();
        this.selectedEmail = null;
        this.selectedFile = null;
        this.query = new GetSMTPImportLogsListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            keywords: null,
            sort: this.sorter.currentSort
        });
        this.detailsQuery = new GetSMTPImportLogListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            keywords: null,
            sort: this.detailsSorter.currentSort
        });
    }
    created() {
        this.resetDateFilterOption();
    }
    ;
    search() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            this.working = true;
            this.loading = true;
            let query = this.query;
            let startTime = query.From ? DateHelper.convertToDate(query.From.toString()) : null;
            let endTime = query.To ? DateHelper.convertToDate(query.To.toString()) : null;
            if (endTime != null)
                endTime = DateHelper.getEndOfDay(endTime);
            if (!DateHelper.validateDateRange(startTime, endTime)) {
                this.loading = false;
                this.working = false;
                Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
                return;
            }
            query.From = startTime;
            query.To = endTime;
            //query.timezoneOffset = DateHelper.getTimezoneOffset();
            return yield smtpImporterClient.getLogs(query)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                if (response) {
                    this.data = response;
                    this.query.pageNo = this.data.displayedPage;
                    this.query.pageSize = this.data.pageSize;
                }
            }))
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.loading = false;
                this.searchAttempted = true;
            });
        });
    }
    ;
    initializeLogDetailsModel() {
        let model = new SMTPImportLogDetailModel();
        model.emails = new Array();
        model.files = new Array();
        model.messages = new Array();
        return model;
    }
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.sort = this.sorter.currentSort;
            yield this.search();
        });
    }
    ;
    onPageChanged() {
        this.search();
    }
    ;
    onPeriodChanged() {
        if (this.areDatesInvalid || this.startDateInvalid || this.endDateInvalid)
            return;
        this.search();
    }
    onDetailsSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.detailsQuery.sort = this.detailsSorter.currentSort;
            this.getLogDetails();
        });
    }
    ;
    onDetailsPageChanged() {
        try {
            this.getLogDetails();
        }
        catch (e) {
            console.error('error onDetailsPageChanged()', e);
        }
    }
    ;
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.pageNo = 1;
            return yield this.search();
        });
    }
    ;
    formatTimeString(date) {
        return DateHelper.convertToFriendlyMomentTimeString(date);
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    resetDateFilterOption() {
        this.setDateFilterOption("Week");
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
        this.search();
    }
    ;
    setDateRange() {
        let range = DateHelper.getDateRange(DatePresetOption.OneMonth);
        let now = new Date();
        let end = moment(now.toISOString()).endOf("day").toDate();
        switch (this.dateFilterOption) {
            case "1 Day":
                range = { start: moment(now.toISOString()).add(-1, "days").startOf("day").toDate(), end: end };
                break;
            case "3 Days":
                range = { start: moment(now.toISOString()).add(-3, "days").startOf("day").toDate(), end: end };
                break;
            case "5 Days":
                range = { start: moment(now.toISOString()).add(-5, "days").startOf("day").toDate(), end: end };
                break;
            case "Week":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "Month":
                range = DateHelper.getDateRange(DatePresetOption.OneMonth);
                break;
        }
        if (!range)
            return;
        this.query.from = range.start;
        this.query.to = range.end;
    }
    ;
    get areDatesInvalid() {
        if (this.query.from == null || this.query.to == null || this.startDateInvalid || this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.query.from.toString());
        let endTime = DateHelper.convertToDate(this.query.to.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.query.from)
            return true;
        try {
            return isNaN(Date.parse(this.query.from.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.query.to)
            return true;
        try {
            return isNaN(Date.parse(this.query.to.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    getLogDetails(log) {
        var _a;
        if (this.working)
            return;
        this.working = true;
        this.detailsQuery.smtpImportLogId = (_a = log === null || log === void 0 ? void 0 : log.id) !== null && _a !== void 0 ? _a : this.detailsQuery.smtpImportLogId;
        this.detailsQuery.sorter = this.detailsSorter.currentSort;
        this.detailsQuery.keywords = this.query.keywords;
        smtpImporterClient.getLogDetails(this.detailsQuery)
            .then(response => {
            this.logDetails = response;
            this.viewingLogDetails = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    view(log) {
        if (this.hasSelection())
            return;
        this.getLogDetails(log);
    }
    ;
    cancel() {
        this.viewingLogDetails = false;
        this.logDetails = this.initializeLogDetailsModel();
        this.selectedEmail = null;
        this.selectedFile = null;
    }
    ;
    selectEmail(email) {
        if (this.hasSelection())
            return;
        this.selectedEmail = email;
    }
    getFilesToDisplay() {
        if (!this.selectedEmail)
            return null;
        return this.logDetails.files.filter(item => item.smtpImportEmailLogId == this.selectedEmail.id);
    }
    hasSelection() {
        var _a;
        var selection = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString();
        return selection !== "";
    }
    selectFile(file) {
        if (this.hasSelection())
            return;
        this.selectedFile = file;
    }
    getMessagesToDisplay() {
        if (!this.selectedFile)
            return null;
        return this.logDetails.messages.filter(item => item.smtpImportFileLogId == this.selectedFile.id);
    }
    getSMTPImporterStatusText(status) {
        switch (status) {
            case SMTPImportStatusEnum.Running: return 'Running';
            case SMTPImportStatusEnum.ForcedShutdown: return 'Forced Shutdown';
            case SMTPImportStatusEnum.GracefulShutdown: return 'Graceful Shutdown';
        }
    }
    getStatusText(status) {
        switch (status) {
            case SMTPImportEmailLogStatus.Processing: return 'Processing';
            case SMTPImportEmailLogStatus.Sucess: return 'Success';
            case SMTPImportEmailLogStatus.Error: return 'Error';
            case SMTPImportEmailLogStatus.Warning: return 'Warning';
        }
    }
    getMesssageTypeText(type) {
        switch (type) {
            case SMTPImportFileMessageTypeEnum.Error: return 'Error';
            case SMTPImportFileMessageTypeEnum.Warning: return 'Warning';
        }
    }
    get showEmailsModal() {
        return this.viewingLogDetails && this.selectedEmail == null;
    }
    get showFilesModal() {
        return this.viewingLogDetails && this.selectedEmail != null && this.selectedFile == null;
    }
    get showMessagesModal() {
        return this.viewingLogDetails && this.selectedEmail != null && this.selectedFile != null;
    }
};
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], SMTPImportLogsVue.prototype, "onSortChanged", null);
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SMTPImportLogsVue.prototype, "onPageChanged", null);
__decorate([
    Watch("query.From"),
    Watch("query.To"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SMTPImportLogsVue.prototype, "onPeriodChanged", null);
__decorate([
    Watch("detailsSorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], SMTPImportLogsVue.prototype, "onDetailsSortChanged", null);
__decorate([
    Watch("detailsQuery.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SMTPImportLogsVue.prototype, "onDetailsPageChanged", null);
SMTPImportLogsVue = __decorate([
    Component({
        name: "SMTPImportLogsVue"
    })
], SMTPImportLogsVue);
export default SMTPImportLogsVue;
